import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table, Modal} from 'react-bootstrap';
import swal from 'sweetalert';
import FlatButton from 'material-ui/FlatButton';
import moment from 'moment';

var Config = require('../../../config');

class ModalDetails extends Component{
	constructor(props){
		super(props);

		this.handleShow = this.handleShow.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.state = {
			show: false,
			center_name:"",
			date:"",
			health_service:"",
			observations:"",
			person_receives:"",
			person_send:"",
			products:[],
		}
	}

	componentDidMount(){
		this.props.onRef(this);
	}

	handleShow(item){

		this.props.waiting.handleShow('Cargando...');
		fetch(Config.default.apiGateway.URL+'supplies_exit/'+item.id,{
			method:'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					show: true,
					center_name:response.center_name,
					date:moment(response.date).format('DD/MM/YYYY'),
					health_service:response.health_service,
					observations:response.observations,
					person_receives:response.person_receives,
					person_send:response.person_send,
					products:response.products
				});
			}
		})
	}


	handleClose(){
		this.setState({
			show: false,
			center_name:"",
			date:"",
			health_service:"",
			observations:"",
			person_receives:"",
			person_send:"",
			products:[],
		});
	}

	render(){
		const {t} = this.props;
		return (
			<Modal bsSize="lg" show={this.state.show} onHide={this.handleClose}>
		       	<Modal.Header closeButton>
		        	<Modal.Title>Detalles de Salida</Modal.Title>
		        </Modal.Header>
		        <Modal.Body >
		        	<div className="row">
		        		<div className="col-xs-12 form-group">
		        			<div className="col-xs-12 col-sm-2">
		        				<span className="span-min">Fecha</span>
		        				<input type="text" className="form-control" value={this.state.date} disabled/>
		        			</div>
		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Usuario Envía</span>
		        				<input type="text" className="form-control" value={this.state.person_send} disabled/>
		        			</div>

		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Unidad Médica Solicita</span>
		        				<input type="text" className="form-control" disabled
		        					value={this.state.center_name} />
		        			</div>
		        			<div className="col-xs-12 col-sm-4">
		        				<span className="span-min">Especialidad</span>
		        				<input type="text" className="form-control" value={this.state.health_service || ""} disabled/>
		        			</div>

		        			<div className="col-xs-12 col-sm-3">
		        				<span className="span-min">Persona Recibe</span>
		        				<input type="text" className="form-control" disabled
		        					value={this.state.person_receives} />
		        			</div>
		        			<div className="col-xs-12 col-sm-9">
		        				<span className="span-min">Observaciones</span>
		        				<input type="text" className="form-control" disabled
		        					value={this.state.observations} />
		        			</div>
		        		</div>
		        		<div className="col-xs-12">
		        			
		        			<Table responsive hover>
		        				<thead>
				                  	<tr>
				                  		<th>Insumo</th>
					                    <th>Lote</th>
					                    <th>Cantidad</th>
				                  	</tr>
				                </thead>
				                <tbody>
				                 	{this.state.products.map( (d, index) => (
				                    	<tr key={index}>
				                    		<td>{d.product_name}</td>
				                      		<td>{d.lot_number}</td>
						                    <td>{d.amount}</td>
				                    	</tr>
				                  	))}
				                </tbody>
		        			</Table>

		        		</div>
		        	</div>
		        </Modal.Body>
		        <Modal.Footer>
		        	<FlatButton primary={true} label={t('content.generics.buttons.close')}  onClick={this.handleClose}/>
		        </Modal.Footer>
		    </Modal>

		)
	}

} 

export default translate('translations') (ModalDetails);